import React, { FC } from "react";
import "./VideoSourceDropdown.scss";

type VideoSourceDropdownProps = {
  videoDevices: MediaDeviceInfo[];
  selectedVideoDevice: string | null;
  onSelect: (deviceId: string) => void;
};

const VideoSourceDropdown: FC<VideoSourceDropdownProps> = ({
  videoDevices,
  selectedVideoDevice,
  onSelect,
}) => {
  if (videoDevices.length === 0) return null;

  return (
    <div className="settings-row">
      <label className="control-label">Video Source:</label>
      <div className="settings-row-controls">
        <select
          className="btn btn-light btn-extra-small media-source-select"
          value={selectedVideoDevice ?? ""}
          onChange={(e) => onSelect(e.target.value)}
        >
          {videoDevices.map((device, index) => (
            <option key={device.deviceId} value={device.deviceId}>
              {device.label || `Video Source ${index + 1}`}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default VideoSourceDropdown;
